import React, { useEffect, useState } from 'react';
import SliderProducts from 'components/Home/SliderProductsBanner/SliderProducts';
import productsStore from 'stores/new/Products';
import PubSub from 'services/PubSub';
import { actionsType } from 'config/constants';
import productAction from 'actions/Product';
import PropTypes from 'prop-types';
import LoginService from 'services/Login';
import { hasfrequentProductsFlag, frequentProductsID } from 'config';
import Link from 'components/Link';
import TagManager from 'services/TagManager'
import useVariant from 'hooks/useVariant';
import style from './style.scss'; //NOSONAR


let actions = [];

const FrequentProducts = (props) => {
    const [products, setProducts] = useState([]);
    const [isError, setError] = useState(false);
    const [isLogged, setIsLogged] = useState(false);
    const { store } = props;

    const variantFrequentProduct = useVariant(frequentProductsID);
    const newVariantFrequentProduct = variantFrequentProduct === '1';

    useEffect(() => {
        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => {
            setProducts([]);
            getContent();
        }));

        actions.push(PubSub.register(actionsType.LOGGED_IN, () => {
            setError(false);
            setIsLogged(true);
            getContent();
        }));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    useEffect(() => {
        let prods = store.products.get('frequent-products');

        if(prods && prods.toList){
            prods = prods.toList().toArray();

            prods = prods.map((product, i) => {
                product.pos = i;
                return product
            })

            setProducts(prods);
        }else{
            setProducts([])
        }
    }, [store]);

    useEffect(() => {
        setIsLogged(LoginService.isLogged());
        getContent();
    }, []);

    const getContent = () => {
        productAction.getFrequentProducts().then(data => {
            if(!(data && data.length > 1)){
                setError(true);
            }
        });
    };

    const clickTagManager = ()  => {
        TagManager.clickLink(!newVariantFrequentProduct ? 'Variante 0' : 'Variante 1', 'Productos Frecuentes', 'Home - Productos frecuentes');
    }

    if(isError || !isLogged || !hasfrequentProductsFlag) return '';

    return (
        <section className="frequent-products">
            <div className="frequent-products-header">
                <h1 className="frequent-products-title">Productos frecuentes</h1>
                <Link className="new-link frequent-products-link" to={'/productos-frecuentes'} target={'_self'} onClick={() => clickTagManager()}>
                    <span className='frequent-products-link-text'>{'Ver todos'}</span>
                </Link>
            </div>
            <div className="frequent-products-items">
                <SliderProducts products={products} isLoading={!products.length} listTitle='Productos Frecuentes'/>
            </div>
        </section>
    )
}
FrequentProducts.propTypes = {
    store: PropTypes.object
}

export default productsStore.wrapConsumer(FrequentProducts);
